import launchpad from './launchpad';

export default {
  launchpad,
};
